import { render, staticRenderFns } from "./FeedbackForm.vue?vue&type=template&id=1b526f73&"
import script from "./FeedbackForm.vue?vue&type=script&lang=js&"
export * from "./FeedbackForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/plenty/Desktop/work/feedback-plugin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b526f73')) {
      api.createRecord('1b526f73', component.options)
    } else {
      api.reload('1b526f73', component.options)
    }
    module.hot.accept("./FeedbackForm.vue?vue&type=template&id=1b526f73&", function () {
      api.rerender('1b526f73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/singleitem/FeedbackForm.vue"
export default component.exports